<template>
  <div id="layout-wrapper">
    <TopBar />

    <SideBarComponent
      class="side-br"
      :type="layout.leftSidebarType"
      :width="layout.layoutWidth"
      @toggleMenu="toggleMenu"
    />

    <div class="main-content">
      <div class="page-content">
        <BContainer fluid>
          <slot />
        </BContainer>
      </div>
      <Footer v-if="false" />
    </div>

    <RightSideBar />
  </div>
</template>

<script setup>
import { onMounted, onBeforeUnmount, computed } from 'vue'
import { useRouter } from 'vue-router'
import { useLayoutStore } from '~/stores/layout'

import TopBar from '~/components/layouts/vertical/TopBar.vue'
import SideBarComponent from '~/components/layouts/common/SideBar.vue'
import Footer from '~/components/layouts/common/Footer.vue'
import RightSideBar from '~/components/layouts/common/RightSideBar.vue'
// ✅ OVDE JE FALILO
const emit = defineEmits(['toggleMenu'])
const layoutStore = useLayoutStore()
const layout = computed(() => layoutStore)

const router = useRouter()
let removeAfterEachHook = null

const isDesktop = () => window.innerWidth >= 992

// Jedina istina: trenutno collapsed ili ne (čitamo sa body-a)
const isCollapsedNow = () => {
  return (
    document.body.classList.contains('vertical-collpsed') ||
    document.body.getAttribute('data-sidebar-size') === 'small'
  )
}

const setCollapsed = (collapsed) => {
  // Ne diramo boju (data-sidebar) uopšte.
  // Samo size/collapse klase + atributi.
  if (collapsed) {
   

    document.body.classList.add('vertical-collpsed')
    document.body.setAttribute('data-sidebar-size', 'small')
    document.body.setAttribute('data-keep-enlarged', 'true')
  } else {
 
    
    document.body.classList.remove('vertical-collpsed')
    document.body.removeAttribute('data-sidebar-size')
    document.body.removeAttribute('data-keep-enlarged')
  }
}

const normalizeForMode = () => {
  if (!process.client) return

  if (isDesktop()) {
    // desktop: nikad overlay
    document.body.classList.remove('sidebar-enable')
  } else {
    // mobile: nema collapse režima
    document.body.classList.remove('vertical-collpsed')
    document.body.removeAttribute('data-sidebar-size')
    document.body.removeAttribute('data-keep-enlarged')
  }
}

onMounted(() => {
  if (!process.client) return

  document.body.removeAttribute('data-layout')
  document.body.setAttribute('data-layout', 'vertical')

  normalizeForMode()

  // posle navigacije zatvori mobile overlay (1x)
  const unregister = router.afterEach(() => {
    document.body.classList.remove('sidebar-enable')
  })
  removeAfterEachHook = typeof unregister === 'function' ? unregister : null

  window.addEventListener('resize', normalizeForMode)
})

onBeforeUnmount(() => {
  if (removeAfterEachHook) removeAfterEachHook()
  if (process.client) window.removeEventListener('resize', normalizeForMode)
})

const toggleMenu = () => {

  
  if (!process.client) return

  if (isDesktop()) {
 
    const collapsed = isCollapsedNow()
 

    setCollapsed(!collapsed)
  } else {
       

    document.body.classList.toggle('sidebar-enable')
  }
}
</script>
